import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { formValueSelector } from 'redux-form'
import { Chart } from 'react-google-charts'

import styles from './style.css'
import stylesLoading from 'components/NoDataAndLoading/NoDataAndLoading.css'
import { pageRequest, getDataAsyncDasboardUrls3, setFlagErrorPusherAsyncDashboard, setFilterDataAsyncDashboard, setFlagAsyncDashboard } from 'actions/dashboard'
import NoData from './NoData'
import TopItemsByCategoryAllChart from './TopItemsByCategoryAllChart'
import { currencyFormatter, rupiah } from 'utils/formatter'
import ActionBar from './ActionBar'
import NoDataAndLoading from 'components/NoDataAndLoading'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import {browserHistory, Link} from 'react-router'
import ChartLoadingSpinner from './ChartLoadingSpinner'
import { subscribePusherAsync } from 'utils/pusher'

class Dashboard extends React.Component {
  // need to have differend graph_id for 2 different <Dashboard component (rendered on <Layout/> - sidebar version and non version
  static renderCounter = 0;

  componentWillReceiveProps (nextProps) {
    const {dispatch} = this.props
    let businessId = this.props.data.moka.user.business.id
    let usersId = this.props.data.moka.user.id
    let flagAsync = nextProps.data.dashboard.index.flag_async
    let currentFlagAsync = this.props.data.dashboard.index.flag_async
    if (flagAsync && flagAsync === true && flagAsync !== currentFlagAsync) {
      subscribePusherAsync(businessId, usersId).bind('dashboards', (results) => {
        const filterHeader = this.props.data.form.search.values
        if (results.status === 'OK') {
          dispatch(setFlagErrorPusherAsyncDashboard(false))
          dispatch(getDataAsyncDasboardUrls3(results, filterHeader))
        } else {
          dispatch(setFlagErrorPusherAsyncDashboard(true))
          dispatch(setFilterDataAsyncDashboard([], null, null))
          dispatch(setFlagAsyncDashboard(false))
          dispatch(showPageLoadingSpinner(false))
        }
      })
    }
  }
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    let flagAsync = this.props.data.dashboard.index.flag_async
    let outletsAsync = this.props.data.dashboard.index.outlet_ids_async
    let startDateAsync = this.props.data.dashboard.index.start_date_async
    let endDateAsync = this.props.data.dashboard.index.end_date_async
    const currentDashboardData = this.props.data.dashboard.index
    const expireTime = 365 // expire time 1 year
    if (!expired) {
      // TODO HIGH change based on update_filtered_date
      this.props.dispatch(pageRequest(flagAsync, outletsAsync, startDateAsync, endDateAsync, currentDashboardData))
      if (Cookies.get('labelNew') === 'true') {
        Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime })
      }
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    const tableManagementReport = this._tableManagementReport()
    const dailyGrossSalesAmount = this._dailyGrossSalesAmount()
    const categorySalesAmountByVolume = this._categorySalesAmountByVolume()
    const categorySalesAmountByRevenue = this._categorySalesAmountByRevenue()
    const dayOfWeekSalesAmount = this._dayOfWeekSalesAmount()
    const hourlySalesAmount = this._hourlySalesAmount()
    const topItems = this._topItems()
    let {showLoadingSpinnerPage} = this.props.data.loadingSpinner
    let flagAsync = this.props.data.dashboard.index.flag_async
    let flagErrorPusherAsync = this.props.data.dashboard.index.flag_error_pusher_dashboard_async
    let outletIdsAsync = this.props.data.dashboard.index.outlet_ids_async
    let descAsync
    let descError
    flagAsync !== undefined && flagAsync === true ? descAsync = 'It looks like we need more time to display the result please come back later. Do not close this tab !' : descAsync = ''
    flagErrorPusherAsync ? descError = 'We can’t process your request at this times. We apologize for any inconvenience caused' : descError = 'You can make transactions through your device, or select different time frame.'
    return (
      <div className='container-full-nosub ng-scope' id='moka-dashboard'>
        <div className='row'>
          <div className={`col-xs-12 ${styles.bottom}`}>
            <div className='row'>
              <ActionBar />
            </div>

            <div className='row'>
              <div className='col-xs-12'>
                <h2 className={styles['title-section']}>SALES SUMMARY</h2>
              </div>
            </div>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={this.noTransaction()}
              title='No Sales'
              description={descError}
              linkLabel='View Dashboard'
              linkUrl='https://mokaposhelp.zendesk.com/hc/en-us/articles/115005342627-View-Dashboard '
              loadingDescription={<div className={styles.description}><p>{descAsync}</p></div>}
              loadingDescriptionAfterChangeMenu={outletIdsAsync !== undefined ? outletIdsAsync.length > 0 && this.noTransaction() && !showLoadingSpinnerPage &&
                <div className={`${stylesLoading['full-height-no-data-display']}`}>
                  <div className={`${stylesLoading['loading-container']} box-spinner`}>
                    <div className={`${stylesLoading['content-loading-spinner']}`}>
                      <img src={require('assets/images/loading-simple.gif')} alt='mokapos spinner' className={stylesLoading['loading-spinner']} />
                      <div className={stylesLoading.description}>
                        <p>It looks like we need more time to display the result please come back later. Do not close this tab !
                        </p>
                      </div>
                    </div>
                  </div>
                </div> : ''}
              />
            {
              !this.noTransaction() > 0 &&
                <div>

                  <div className='row'>
                    <div className='col-xs-12 col-sm-12 col-md-4'>
                      <Link className={styles['linked-dashboard']} title='Click to see report!' to='/reports/sales/summary'>
                        <div className='sales-amount-box'>
                          <div className='title-center'>GROSS SALES</div>
                          <div className={styles['about-box']}>
                            {currencyFormatter(this.props.data.dashboard.index.gross_sales)}
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className='col-xs-12 col-sm-12 col-md-4'>
                      <Link className={styles['linked-dashboard']} title='Click to see report!' to='/reports/sales/summary'>
                        <div className='sales-amount-box'>
                          <div className='title-center'>NET SALES</div>
                          <div className={styles['about-box']}>
                            {currencyFormatter(this.props.data.dashboard.index.net_sales)}
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className='col-xs-12 col-sm-12 col-md-4'>
                      <Link className={styles['linked-dashboard']} title='Click to see report!' to='/reports/sales/gross_profit'>
                        <div className='sales-amount-box'>
                          <div className='title-center'>GROSS PROFIT</div>
                          <div className={styles['about-box']}>
                            {currencyFormatter(this.props.data.dashboard.index.gross_profit)}
                          </div>
                        </div>
                      </Link>
                    </div>

                  </div>

                  <div className='row'>

                    <div className='col-xs-12 col-sm-12 col-md-4'>
                      <Link className={styles['linked-dashboard']} title='Click to see report!' to='/reports/sales/payment_methods'>
                        <div className='sales-amount-box'>
                          <div className='title-center'>TRANSACTIONS</div>
                          <div className={styles['about-box']}>
                            {this.props.data.dashboard.index.total_transactions}
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className='col-xs-12 col-sm-12 col-md-4'>
                      <Link className={styles['linked-dashboard']} title='Click to see report!' to='/reports/transactions'>
                        <div className='sales-amount-box'>
                          <div className='title-center'>AVERAGE SALE PER TRANSACTION</div>
                          <div className={styles['about-box']}>
                            {currencyFormatter(this.avgSales(this.props.data.dashboard.index.net_sales, this.props.data.dashboard.index.total_transactions))}
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className='col-xs-12 col-sm-12ß col-md-4'>
                      <Link className={styles['linked-dashboard']} title='Click to see report!' to='/reports/sales/gross_profit'>
                        <div className='sales-amount-box'>
                          <div className='title-center'>GROSS MARGIN</div>
                          <div className={styles['about-box']}>
                            {this.percentageMargin(this.props.data.dashboard.index.net_sales, this.props.data.dashboard.index.gross_profit) + '%'}
                          </div>
                        </div>
                      </Link>
                    </div>

                  </div>

                  <div className='row'>
                    {dailyGrossSalesAmount.data.length > 2 && <div className='col-xs-12'>
                      <div className={styles['sales-chart-box']}>
                        <div className={styles['title-chart-left']}>DAILY GROSS SALES AMOUNT</div>
                        <div className='my-pretty-chart-container'>
                          <Chart
                            chartType='AreaChart'
                            data={dailyGrossSalesAmount.data}
                            options={this.DAILY_SALES_CHART_OPTIONS}
                            graph_id={`area-chart-daily-${Dashboard.renderCounter}`}
                            width='100%'
                            height='200px'
                            legend_toggle
                            loader={<ChartLoadingSpinner />}
                        />
                        </div>
                      </div>
                    </div>}
                  </div>
                  <div className='row'>
                    <div className='col-xs-12 col-sm-6 col-md-4'>
                      <div className={styles['sales-chart-box']}>
                        <div className={styles['title-chart-left']}>DAY OF THE WEEK GROSS SALES AMOUNT</div>
                        <div className='my-pretty-chart-container'>
                          <Chart
                            chartType='ColumnChart'
                            data={dayOfWeekSalesAmount.data}
                            options={this.DAY_OF_WEEK_SALES_CHART_OPTIONS}
                            graph_id={`area-chart-week-${Dashboard.renderCounter}`}
                            width='100%'
                            height='200px'
                            legend_toggle
                            loader={<ChartLoadingSpinner />}
                        />
                        </div>
                      </div>
                    </div>
                    <div className='col-xs-12 col-sm-6 col-md-8'>
                      <div className={styles['sales-chart-box']}>
                        <div className={styles['title-chart-left']}>HOURLY GROSS SALES AMOUNT</div>
                        <div className='my-pretty-chart-container'>
                          <Chart
                            chartType='AreaChart'
                            data={hourlySalesAmount.data}
                            options={this.HOURLY_SALES_CHART_OPTIONS}
                            graph_id={`area-chart-hourly-${Dashboard.renderCounter}`}
                            width='100%'
                            height='200px'
                            legend_toggle
                            loader={<ChartLoadingSpinner />}
                        />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            }

            <div className='row'>
              <div className='col-xs-12'>
                <h2 className={styles['title-section']}>TABLE MANAGEMENT</h2>
              </div>
            </div>
            <NoDataAndLoading
              halfHeight
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={this.noTableTransaction()}
              title='No Table Order'
              description='You can assign orders to table, or select different time frame'
              loadingDescription={<div className={styles.description}><p>{descAsync}</p></div>}
              loadingDescriptionAfterChangeMenu={outletIdsAsync !== undefined ? outletIdsAsync.length > 0 && this.noTableTransaction() && !showLoadingSpinnerPage &&
                <div className={`${stylesLoading['half-height-no-data-display']}`}>
                  <div className={`${stylesLoading['loading-container']} box-spinner`}>
                    <div className={`${stylesLoading['content-loading-spinner']}`}>
                      <img src={require('assets/images/loading-simple.gif')} alt='mokapos spinner' className={stylesLoading['loading-spinner']} />
                      <div className={stylesLoading.description}>
                        <p>It looks like we need more time to display the result please come back later. Do not close this tab !
                        </p>
                      </div>
                    </div>
                  </div>
                </div> : ''}
              />
            {
              !this.noTableTransaction() > 0 &&
                <div>
                  <div className='row'>
                    <div className='col-xs-12 col-sm-6 col-md-4'>
                      <div className={styles['table-management-box']}>
                        <div className='title-left'>TOTAL PAX</div>
                        <div className={styles['about-box']}>{tableManagementReport.totalPax}</div>
                      </div>
                    </div>
                    <div className='col-xs-12 col-sm-6 col-md-4'>
                      <div className={styles['table-management-box']}>
                        <div className='title-left'>AVG REVENUE PER PAX</div>
                        <div className={styles['about-box']}>{tableManagementReport.avgRevenue}</div>
                      </div>
                    </div>
                    <div className='col-xs-12 col-sm-6 col-md-4'>
                      <div className={styles['table-management-box']}>
                        <div className='title-left'>AVG DINE IN TIME PER TABLE</div>
                        <div className={styles['about-box']}>{tableManagementReport.avgTime}</div>
                      </div>
                    </div>
                  </div>
                </div>
            }

            <div className='row'>
              <div className='col-xs-12'>
                <h2 className={styles['title-section']}>ITEM SUMMARY</h2>
              </div>
            </div>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={this.noTransaction()}
              title='No Sales'
              description={descError}
              loadingDescription={<div className={styles.description}><p>{descAsync}</p></div>}
              loadingDescriptionAfterChangeMenu={outletIdsAsync !== undefined ? outletIdsAsync.length > 0 && this.noTransaction() && !showLoadingSpinnerPage &&
                <div className={`${stylesLoading['full-height-no-data-display']}`}>
                  <div className={`${stylesLoading['loading-container']} box-spinner`}>
                    <div className={`${stylesLoading['content-loading-spinner']}`}>
                      <img src={require('assets/images/loading-simple.gif')} alt='mokapos spinner' className={stylesLoading['loading-spinner']} />
                      <div className={stylesLoading.description}>
                        <p>It looks like we need more time to display the result please come back later. Do not close this tab !
                        </p>
                      </div>
                    </div>
                  </div>
                </div> : ''} />
            {
              !this.noTransaction() > 0 &&
                <div>
                  <div className='row'>
                    <div className='col-xs-12 col-md-4'>
                      <div className={styles['sales-chart-box']}>
                        <div className={styles['title-chart-left']}>CATEGORY BY VOLUME</div>
                        <div className='my-pretty-chart-container'>
                          {!!categorySalesAmountByVolume.rows.length && <Chart
                            chartType='PieChart'
                            rows={categorySalesAmountByVolume.rows}
                            colors={categorySalesAmountByVolume.colors}
                            columns={this.CATEGORY_SALES_BY_VOLUMES_CHART_COLUMNS}
                            options={this.CATEGORY_SALES_BY_VOLUMES_CHART_OPTIONS}
                            graph_id={`area-chart-volume-${Dashboard.renderCounter}`}
                            width='100%'
                            height='200px'
                            legend_toggle
                            loader={<ChartLoadingSpinner />}
                        />}
                          {!categorySalesAmountByVolume.rows.length && <NoData />}
                        </div>
                      </div>
                    </div>
                    <div className='col-xs-12 col-md-4'>
                      <div className={styles['sales-chart-box']}>
                        <div className={styles['title-chart-left']}>CATEGORY BY SALES</div>
                        <div className='my-pretty-chart-container'>
                          {!!categorySalesAmountByRevenue.rows.length && <Chart
                            chartType='PieChart'
                            rows={categorySalesAmountByRevenue.rows}
                            colors={categorySalesAmountByRevenue.colors}
                            columns={this.CATEGORY_SALES_BY_REVENUES_CHART_COLUMNS}
                            options={this.CATEGORY_SALES_BY_REVENUES_CHART_OPTIONS}
                            graph_id={`area-chart-sales-${Dashboard.renderCounter}`}
                            width='100%'
                            height='200px'
                            legend_toggle
                            loader={<ChartLoadingSpinner />}
                        />}
                          {!categorySalesAmountByRevenue.rows.length && <NoData />}
                        </div>
                      </div>
                    </div>
                    <div className='col-xs-12 col-md-4'>
                      <div className={styles['sales-chart-box']}>
                        <div className={styles['title-chart-left']}>TOP ITEMS</div>
                        <div className='my-pretty-chart-container'>
                          {(topItems.rows.length > 0) && <Chart
                            chartType='Table'
                            columns={this.TOP_ITEMS_CHART_COLUMNS}
                            rows={topItems.rows}
                            options={{}}
                            graph_id={`area-chart-top-item-${Dashboard.renderCounter}`}
                            width='100%'
                            height='200px'
                            legend_toggle
                            loader={<ChartLoadingSpinner />}
                        />}
                          {!topItems.rows.length && <NoData />}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xs-12'>
                      <div className='mk-sales-chart-box'>
                        <div className={styles['title-chart-left']}>TOP ITEMS BY CATEGORY</div>
                        <div className='row'>
                          <TopItemsByCategoryAllChart
                            topItemsByCategory={this.props.data.dashboard.index.topItemsByCategory}
                            ChartLoadingSpinner={ChartLoadingSpinner}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            }
          </div>
        </div>
      </div>
    )
  }

  componentDidUpdate () {
    ++Dashboard.renderCounter
  }

  avgSales (netSales, numTransaction) {
    return netSales / (numTransaction || 1)
  }

  percentageMargin (netSales, grossProfit) {
    return isNaN((grossProfit / netSales) * 100) ? 0 : (grossProfit / netSales) * 100
  }

  noTransaction () {
    const {dailyGrossSales, weeklyGrossSales, hourlyGrossSales} = this.props.data.dashboard.index
    return dailyGrossSales.length === 0 && weeklyGrossSales.length === 0 && hourlyGrossSales.length === 0
  }

  noTableTransaction () {
    let {tableManagementReport} = this.props.data.dashboard.index
    return !tableManagementReport.totalPax && !tableManagementReport.avgRevenue && !tableManagementReport.avgTime
  }

  _tableManagementReport = () => {
    let {tableManagementReport} = this.props.data.dashboard.index
    return {
      totalPax: tableManagementReport.totalPax || '0',
      avgRevenue: tableManagementReport.avgRevenue ? rupiah(tableManagementReport.avgRevenue) : 'Rp 0',
      avgTime: tableManagementReport.avgTime ? tableManagementReport.avgTime + ' Minutes' : '0 Minutes'
    }
  }

  _dailyGrossSalesAmount = () => {
    let {dailyGrossSales} = this.props.data.dashboard.index
    let rows = []
    rows.push([{role: 'domain'}, 'Gross Sales'])
    dailyGrossSales.forEach((transaction) => {
      rows.push([
        moment(transaction.date).format('DD-MM-YYYY'),
        {
          v: transaction.sumGrossSales,
          f: rupiah(transaction.sumGrossSales) + ' \n Num Sales: ' + transaction.numSales
        }
      ])
    })
    return {data: rows}
  }

  _dayOfWeekSalesAmount = () => {
    let {weeklyGrossSales} = this.props.data.dashboard.index
    let result = []

    // PUSH HEADER
    result.push([{role: 'domain'}, 'Gross Sales'])
    weeklyGrossSales.forEach((transactionDayOfWeek) => {
      result.push([
        transactionDayOfWeek.dayOfWeek,
        {
          v: transactionDayOfWeek.sumGrossSales,
          f: rupiah(transactionDayOfWeek.sumGrossSales) + ' \n Num Sales: ' + transactionDayOfWeek.numSales
        }
      ])
    })
    return {data: result}
  }

  _hourlySalesAmount = () => {
    let {hourlyGrossSales} = this.props.data.dashboard.index
    let result = []
    // push header
    result.push([{role: 'domain'}, 'Gross Sales'])
    // push data
    hourlyGrossSales.forEach((transactionHourly) => {
      result.push([
        transactionHourly.hour,
        {
          v: transactionHourly.sumGrossSales,
          f: rupiah(transactionHourly.sumGrossSales) + ' \n Num Sales: ' + transactionHourly.numSales
        }
      ])
    })
    return {data: result}
  }

  _categorySalesAmountByRevenue = () => {
    let {categorySalesAmountByRevenue} = this.props.data.dashboard.index
    let rows = []
    let colors = []
    let newColor = this.getRandomColor()
    Object.entries(categorySalesAmountByRevenue).map(([key, value]) => {
      colors.push(newColor)
      rows.push([key, value.revenue, value.pctRevenue])
    })
    rows = rows.sort((a, b) => {
      return (b[1] - a[1])
    })
    return {rows, colors}
  }

  _categorySalesAmountByVolume = () => {
    let {categorySalesAmountByVolume} = this.props.data.dashboard.index
    let rows = []
    let colors = []
    let newColor = this.getRandomColor()
    Object.entries(categorySalesAmountByVolume).map(([key, value]) => {
      colors.push(newColor)
      rows.push([key, value.volume, value.pctVolume])
    })
    rows = rows.sort((a, b) => {
      return (b[1] - a[1])
    })
    return {rows, colors}
  }

  _topItems = () => {
    let {top_items} = this.props.data.dashboard.index
    let rows = []
    top_items.forEach((item) => {
      rows.push([item.name, item.count, {v: item.revenue, f: rupiah(item.revenue)}])
    })
    return {rows}
  }

  getRandomColor () {
    let letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  }

  CATEGORY_SALES_BY_REVENUES_CHART_OPTIONS = {
    isStacked: true,
    fill: 20,
    displayExactValues: true,
    vAxis: {title: 'Category Sales by Sales', gridlines: {count: 0}},
    hAxis: {title: 'Date'},
    is3D: false
  }

  CATEGORY_SALES_BY_REVENUES_CHART_COLUMNS = [
    {id: 'item', label: 'Item', type: 'string'},
    {id: 'sales', label: 'Sales', type: 'number'},
    {id: 'percent', label: 'Percent', type: 'number'}
  ]

  CATEGORY_SALES_BY_VOLUMES_CHART_OPTIONS = {
    isStacked: true,
    fill: 20,
    displayExactValues: true,
    vAxis: {title: 'Category Sales by Volume', gridlines: {count: 20}},
    hAxis: {title: 'Date'},
    is3D: false
  }

  CATEGORY_SALES_BY_VOLUMES_CHART_COLUMNS = [
    {id: 'item', label: 'Item', type: 'string'},
    {id: 'sales', label: 'Sales', type: 'number'},
    {id: 'percent', label: 'Percent', type: 'number'}
  ]

  // Tambahan ada toolTip: isHtml true
  DAY_OF_WEEK_SALES_CHART_OPTIONS = {
    title: '',
    isStacked: true,
    fill: 20,
    displayExactValues: true,
    vAxis: {title: '', gridlines: {count: 10, color: 'transparent'}},
    legend: {position: 'none'},
    hAxis: {title: ''},
    colors: ['#3498DB', '#3498DB'],
    areaOpacity: 1.0
  }

  HOURLY_SALES_CHART_OPTIONS = {
    title: '',
    isStacked: true,
    fill: 20,
    displayExactValues: true,
    legend: {position: 'none'},
    vAxis: {title: '', gridlines: {count: 10, color: 'transparent'}, textStyle: {fontSize: 10}},
    hAxis: {
      title: '',
      gridlines: {count: 24, color: 'transparent'},
      textStyle: {fontSize: 10},
      baselineColor: 'transparent'
    },
    colors: ['#3498DB', '#3498DB'],
    areaOpacity: 1.0
  }

  TOP_ITEMS_CHART_COLUMNS = [
    {'type': 'string', 'label': 'Item'},
    {'type': 'number', 'label': 'Volume'},
    {'type': 'number', 'label': 'Sales'}
  ]

  DAILY_SALES_CHART_OPTIONS = {
    title: '',
    isStacked: true,
    fill: 20,
    displayExactValues: true,
    legend: {position: 'none'},
    vAxis: {title: '', gridlines: {count: 10, color: 'transparent'}},
    hAxis: {title: ''},
    colors: ['#3498DB', '#3498DB'],
    areaOpacity: 1.0
  }
}

Dashboard.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  rupiah: React.PropTypes.func
}

const selector = formValueSelector('search')

// Which props do we want to inject, given the global state?
function select (state) {
  return {
    data: state,
    search: {
      date: selector(state, 'date'),
      outletIds: selector(state, 'outlet')
    }
  }
}

// Wrap the component to inject dispatch and state into it
export default connect(select)(Dashboard)



// WEBPACK FOOTER //
// ./app/pages/Dashboard/Dashboard.js